import React from "react"
import styles from "./styles.scss"
import { connect } from "react-redux"
import { getCounties, selectCountiesAsArray } from "data/counties"
import { getCategories, selectCategoriesAsArray } from "data/categories"
import Header, { SIZES } from "components/Header"
import Footer from "components/Footer"
import InfoContainer from "pages/LandingPage/components/InfoContainer"
import SearchBarWrapper from "components/SearchBarWrapper"
import CategoriesContainer from "./components/CategoriesContainer"

class LandingPage extends React.Component {
  state = {
    county: "",
    categoryId: "",
  }

  handleSelectCounty = county => {
    this.setState({ county })
  }

  handleSelectCategory = id => {
    this.setState({ categoryId: id })
  }

  render() {
    const { categories } = this.props
    return (
      <div className={styles.container}>
        <div className={styles.mainContent}>
          <Header hasSearchBar={false} headerSize={SIZES.MEDIUM} />

          <div className={styles.content}>
            <h2 className={styles.header}>Friskvård och hantverkare</h2>
            <p className={styles.headerText}>
              Välj kommun, sök efter tjänst eller företag, eller välj bland
              de tillgängliga tjänsterna i din kommun.
            </p>
            <p className={styles.headerMobileText}>
              Välj kommun och sök efter tjänst eller företag.
            </p>

            <SearchBarWrapper onSelectCounty={this.handleSelectCounty} />

            <CategoriesContainer
              categories={categories}
              county={this.state.county}
            />

            <InfoContainer />
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}
const mapStateToProps = (state, ownProps) => ({
  counties: selectCountiesAsArray(state, ownProps),
  categories: selectCategoriesAsArray(state, ownProps),
})
export default connect(mapStateToProps, {
  getCounties,
  getCategories,
})(LandingPage)



// WEBPACK FOOTER //
// src/pages/LandingPage/index.jsx